import {GET_ORDERS} from '../types';

const initialState = {
    items: [],
    isLoad: false,
    sideValuesSet: [],
    statusValuesSet: [],
    typeValuesSet: [],
    OrderAlgValuesSet: [],
    isRobotOrderSet: [],
    cycleEndSet: [],
    cycleStageSet: [],
    baseCurrSet: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ORDERS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }

}
